import constant from '@components/common/globalization'
import cn from 'classnames';
import style from './expandedView.module.css';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const PrintOptions = (props) => {
    const { onClose, handlePrint, filteredCheck } = props;
    const printType = [
        { id: 0, lable: FLABEL().PRINT_INDIVIDUAL_ITEM_LABELS },
        { id: 1, lable: FLABEL().PRINT_ORDER_ITEM_LABELS },
        { id: 2, lable: FLABEL().PRINT_FULL_ORDER_LABEL },
        { id: 3, lable: FLABEL().PRINT_KITCHEN_TICKET },
        { id: 4, lable: FLABEL().PRINT_GUEST_RECEIPT },
    ]
    return (
        <div className="w-100 text-center h-100 position-relative fs-16 fw-500 text-center">
            <div className={cn(style.printHeader, 'col-12 text-left')}>{FLABEL().PRINT}</div>
            <div className={cn(style.printerBtnsContainer, 'w-100 ')}>
                {printType.map((item) => (
                    <div className={cn(style.printerBtn, 'col-12 fs-600 d-flex align-items-center justify-content-center')} key={item.id} onClick={() => handlePrint(item.lable, filteredCheck)}>{item.lable}</div>
                ))}
            </div>
            <div className={cn('position-absolute w-25 d-flex align-items-center justify-content-center', style.closeBtn)} onClick={() => onClose('close')}>
                {FLABEL().PRINT_CANCEL}
            </div>
        </div>
    )
}

export default PrintOptions;